var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H16C18.2 0 20 1.8 20 4C20 5.7 19 7.1 17.5 7.7V4C17.5 3.6 17.3 3.2 17.1 2.9C16.9 2.6 16.4 2.5 16 2.5H4C3.6 2.5 3.2 2.7 2.9 2.9C2.6 3.1 2.5 3.6 2.5 4V7.7C1 7.1 0 5.7 0 4C0 1.8 1.8 0 4 0Z",
    fill: "#482701"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.99997V16C16 17.1 15.1 18 14 18H6C4.9 18 4 17.1 4 16V3.99997H16ZM8.5 11.5L9.2 12.2V7.99997C9.2 7.59997 9.5 7.19997 10 7.19997C10.5 7.19997 10.8 7.49997 10.8 7.99997V12.2L11.5 11.5C11.8 11.2 12.3 11.2 12.6 11.5C12.9 11.8 12.9 12.3 12.6 12.6L11.3 13.9C10.6 14.6 9.5 14.6 8.8 13.9L7.5 12.6C7.2 12.3 7.2 11.8 7.5 11.5C7.8 11.2 8.2 11.2 8.5 11.5Z",
    fill: "#482701"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.fec0c3850e053240d11935a311544424.svg";
export { ForwardRef as ReactComponent };